// src/pages/Appli/AppliAdmin/users-admin/components/UsersPagination.jsx

import React from "react";

import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

export default function UsersPagination({
  page,
  pageCount,
  setPage,
  loading,
}) {
  if (pageCount <= 1) return null;

  return (
    <div className="mt-5 flex flex-col items-center justify-between gap-3 rounded-3xl border border-slate-200 bg-white px-4 py-4 sm:flex-row dark:border-slate-800 dark:bg-slate-900">
      <div className="text-sm text-slate-500 dark:text-slate-400">
        Page{" "}
        <span className="font-semibold text-slate-900 dark:text-white">
          {page}
        </span>{" "}
        sur{" "}
        <span className="font-semibold text-slate-900 dark:text-white">
          {pageCount}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() =>
            setPage((currentPage) =>
              Math.max(1, currentPage - 1),
            )
          }
          disabled={page === 1 || loading}
          className="inline-flex h-10 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <FaChevronLeft />
          Précédent
        </button>

        <button
          type="button"
          onClick={() =>
            setPage((currentPage) =>
              Math.min(pageCount, currentPage + 1),
            )
          }
          disabled={page === pageCount || loading}
          className="inline-flex h-10 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          Suivant
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}